{
  "queryName": "downloadSearchResults",
  "queryParam": null,
  "fields": ["fileData"]
}
